import coreModule from 'app/core/core_module';

export class Mixpanel {
  /** @ngInject */
  constructor(private $rootScope, private contextSrv, private $window) {}

  init() {
    this.$rootScope.$on('$viewContentLoaded', () => {
      if (this.contextSrv.isSignedIn && this.contextSrv.user && this.contextSrv.user.id) {
        // To set unique user id in your system when it is available
        this.$window.mixpanel.identify('' + this.contextSrv.user.id);

        let meta = {
          $email: this.contextSrv.user.email,
          //"$created": "2011-03-16 16:53:54",
          $last_name: this.contextSrv.user.name,
        };

        this.$window.mixpanel.people.set(meta);
      }
    });
  }
}

/** @ngInject */
function startMixpanel(mixpanelSrv) {
  mixpanelSrv.init();
}

coreModule.service('mixpanelSrv', Mixpanel).run(startMixpanel);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./public/app/core/services/mixpanel.ts